import DashboardIndex from './features/dashboard/DashboardIndex'
import Incidents from './features/incidents'
import ExportIndex from './features/incidents/ExportIndex'
import Organisations from './features/organisations'
import ImportIndex from './features/organisations/ImportIndex'
import TenantsIndex from './features/tenants/TenantsIndex'

import App from './components/App'

import Login from './features/auth/Login'
import Callback from './features/auth/Callback'
import * as React from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import store from './store.js'
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute.js'
import Roles from './features/auth/Roles.js'

const isAuthenticated = () => {
    if (store.getState().auth.user !== null) {
        store.dispatch.profile.load()
        store.dispatch.organisations.load()
    }

    return store.getState().auth.user !== null
}

const childRoutes = [
    {
        element: <ProtectedRoute isAuthenticated={ isAuthenticated } />,
        children: [
            {
                path: '/',
                label: 'Home',
                element: <DashboardIndex/>
            },
            {
                path: 'incidents/',
                navPath: '/incidents',
                label: 'Incidenten',
                element: <Incidents />,
                navigator: true,
                roles: [ Roles.DataManager ],
                children: [
                    {
                        // When the user navigates to /incidents, redirect to /incidents/export
                        index: true,
                        element: <Navigate to="/incidents/export" replace />
                    },
                    {
                        path: 'export',
                        navPath: '/incidents/export',
                        element: <ExportIndex />
                    }
                ]
            },
            {
                path: 'organisations/',
                navPath: '/organisations',
                label: 'Organisatie',
                element: <Organisations />,
                navigator: true,
                roles: [ Roles.SuperAdmin ],
                children: [
                    {
                        // When the user navigates to /organisations, redirect to /organisations/import
                        index: true,
                        element: <Navigate to="/organisations/import" replace />
                    },
                    {
                        path: 'import',
                        navPath: '/organisations/import',
                        element: <ImportIndex />
                    }
                ]
            },
            {
                path: 'tenants/',
                navPath: '/tenants',
                label: 'Tenants',
                element: <TenantsIndex />,
                navigator: true,
                roles: [ Roles.SuperAdmin ]
            }
        ]
    }
]

const router = createBrowserRouter([
    {
        path: '/',
        label: 'Home',
        element: <App routes={ childRoutes[0].children } />,
        children: childRoutes
    },
    {
        path: 'login',
        element: <Login/>
    },
    {
        path: 'oidc-callback',
        element: <Callback/>
    }
])

const routes = childRoutes[0].children

export default router
export { routes }
